import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ArticleService } from '../data/article.service';
import { articleCommand } from '../../command/article.command';
import { Observable } from 'rxjs';

@Injectable()
export class ArticleExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: ArticleService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === articleCommand.export && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(
        map(file => {
          this._nativeWindow.save(file);
        })
      );
    }
  }
}
